import src from "IMAGE";
export default { src, width: 13, height: 19, blurWidth: 0, blurHeight: 0};
